import { useRef, useState } from "react";
import { useAutocomplete } from "@ubilabs/google-maps-react-hooks";

export const AutoCompleteInput = ({ setLatLng }) => {
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");

  const onPlaceChanged = (place) => {
    if (place?.geometry) {
      setLatLng({
        lat: Number(place.geometry.location.lat()),
        lng: Number(place.geometry.location.lng()),
      });
      setInputValue(place.formatted_address || place.name);
    }
    inputRef.current?.focus();
  };

  useAutocomplete({
    inputField: inputRef && inputRef.current,
    onPlaceChanged,
  });

  return (
    <input
      ref={inputRef}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder="Buscar dirección en Google Maps"
      className="inputBusca crear-servicios-v2 inputBusca"
      style={{ width: "100%" }}
    />
  );
};
